import { Divider, Stack, DialogContent, DialogActions, Dialog } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';

interface Props {
  open: boolean;
  onClose: VoidFunction;
}

const InformationDialog = ({ open, onClose }: Props) => {
  return (
    <>
      <Dialog open={open} fullWidth>
        <Header variant="dialog" title={Strings.page_title.notification} onClose={onClose} />
        <Divider />
        <DialogContent sx={{ mt: 2, mb: 2 }}>
          <Stack>{Strings.leave.yourLeaveIsSavedInDraft}</Stack>
          <Stack fontWeight={600} mt={2}>
            {Strings.leave.actionSendToManager}
          </Stack>
        </DialogContent>
        <Divider />
        <DialogActions>
          <LoadingButton variant="contained" type="submit" onClick={onClose}>
            {Strings.button.ok}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export { InformationDialog };
